import { render, staticRenderFns } from "./scheduler-time-period.vue?vue&type=template&id=2672dbcf&scoped=true&"
import script from "./scheduler-time-period.vue?vue&type=script&lang=js&"
export * from "./scheduler-time-period.vue?vue&type=script&lang=js&"
import style0 from "./scheduler-time-period.vue?vue&type=style&index=0&id=2672dbcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672dbcf",
  null
  
)

component.options.__file = "scheduler-time-period.vue"
export default component.exports